import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilderService } from './form-builder.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [FormBuilderService]
})
export class FormBuilderModule { }
